export class CalibrationReq{
    calibrationId: number;
    plant?:string
    plantId?:number

    constructor(calibrationId: number, plant?:string,
        plantId?:number){
        calibrationId = calibrationId;
        plant = plant
        plantId =plantId
    }

}